import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "scrollable-container__track"
}

import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollableContainer',
  props: {
    hideScrollbar: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { hideScrollbar: boolean }



const scrollableContainerListEl = ref<HTMLDivElement | null>(null);
const scrollbarEl = ref<HTMLDivElement | null>(null);

const canScrollRight = ref(false);

function checkScrollState() {
  if (!scrollableContainerListEl.value) return;

  const { scrollLeft, scrollWidth, clientWidth } =
    scrollableContainerListEl.value;

  canScrollRight.value = scrollLeft + clientWidth < scrollWidth;
}

function updateCustomScrollbar() {
  if (
    props.hideScrollbar ||
    !scrollableContainerListEl.value ||
    !scrollbarEl.value
  )
    return;

  const { scrollLeft, scrollWidth, clientWidth } =
    scrollableContainerListEl.value;

  const scrollbarWidth = (clientWidth / scrollWidth) * clientWidth;
  const scrollbarLeft = (scrollLeft / scrollWidth) * clientWidth;
  scrollbarEl.value.style.width = `${scrollbarWidth}px`;
  scrollbarEl.value.style.transform = `translateX(${scrollbarLeft}px)`;
}

function componentListeners() {
  checkScrollState();
  updateCustomScrollbar();
}

function setupListeners() {
  if (scrollableContainerListEl.value) {
    checkScrollState();
    updateCustomScrollbar();
    scrollableContainerListEl.value.addEventListener(
      'scroll',
      componentListeners
    );
    window.addEventListener('resize', componentListeners);
  }
}

onMounted(() => {
  nextTick(() => {
    componentListeners();
    setupListeners();
  });
});

onBeforeUnmount(() => {
  scrollableContainerListEl.value?.removeEventListener(
    'scroll',
    componentListeners
  );
  window.removeEventListener('resize', componentListeners);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["scrollable-container__list-wrapper", { 'right-shadow': canScrollRight.value }])
  }, [
    _createElementVNode("div", {
      class: "scrollable-container__list",
      ref_key: "scrollableContainerListEl",
      ref: scrollableContainerListEl
    }, [
      _renderSlot(_ctx.$slots, "default"),
      (!__props.hideScrollbar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "scrollable-container_scrollbar",
              ref_key: "scrollbarEl",
              ref: scrollbarEl
            }, null, 512)
          ]))
        : _createCommentVNode("", true)
    ], 512)
  ], 2))
}
}

})